module.exports = __webpack_public_path__ + "img/5584b675a4dcd5db37e6fbec454b686e.png";